export default class en {
  static translations = {
    views: {
      notFound: {
        pageNotFound: 'Page not found.',
      },
      browserNotSupported: {
        message: 'Your Internet browser is not supported.',
      },
    },
    helpers: {
      handle_session_error: {
        loggedOutPrompt: {
          title: 'Logged in from another device?',
          message:
            'You are logged out of this device because you have accessed the system through another device. Was that you?',
        },
        loggedOutAlert: {
          message: 'Your report was sent successfully.',
        },
      },
    },
    components: {
      login: {
        switchDevicePrompt: {
          title: 'You are logged in to another device',
          message:
            'You are already logged in to another browser. Are you sure you want to log out of another browser and access through this one?',
        },
      },
      documentRename: {
        headline: 'Rename a file',
      },
      eventTabDocuments: {
        status: 'Status',
        private: ' Private',
        public: 'Public',
      },
      eventTabQuestionsAndStatistics: {
        questions: 'Elections',
        statistics: 'Statistics',
        /* statistics:
          '\n EN: Statistics - \n ES: Estadísticas - \n FR: Statistiques', */
        noQuestionSelected:
          'In the moment when election starts, you will be able to see the election results or the list of participants here. After the election is completed, you will see the results and a list of participants and their activities.',
        errors: {
          questionNotFound: 'The question was not found in the list.',
        },
      },
      eventTabVotersAndCommunication: {
        voters: 'Participants',
        communicationEmpty:
          'If you have chosen the option of asking questions by the participants, at the time of starting the event, or asking questions of the participants, here you will be able to see and moderate all the questions.',
        live: 'Live',
        archive: 'Archive',
        questions: 'Questions',
      },
      messageList: {
        displayMessage: 'Display messages',
      },
      authorizerCreate: {
        validation: {
          name: {
            required: 'It is necessary to enter the name',
            length: 'The name can have a maximum of 191 characters.',
            unique: 'The name must be unique.',
          },
        },
      },
      authorizerEdit: {
        validation: {
          name: {
            required: 'It is necessary to enter the name',
            length: 'The name can have a maximum of 191 characters.',
            unique: 'The name must be unique.',
          },
        },
      },
      questionCreate: {
        newQuestion: 'New election',
        validation: {
          quorum: {
            integer: 'Value must be an integer.',
            min: 'The minimum value is 1.',
          },
          question: {
            required: 'It is necessary to enter the question',
            length: 'The question can have a maximum of 2000 characters.',
          },
          answers: {
            min: 'You must enter at least two answers.',
            required: 'You must enter an answer.',
          },
          minChoices: {
            min: 'The minimum value is 1.',
            length:
              'The number of answers is less than or equal to the entered value.',
          },
          maxChoices: {
            min: 'The minimum value is 0.',
            length: 'The number of answers is less than 0.',
          },
        },
      },
      questionEdit: {
        editQuestion: 'Edit selection',
        validation: {
          question: {
            required: 'It is necessary to enter a question.',
            length: 'The question can have a maximum of 2000 characters.',
          },
          answers: {
            min: 'You must enter at least two answers.',
            required: 'You must enter an answer.',
          },
          minChoices: {
            min: 'The minimum value is 1.',
            length:
              'The number of answers is less than or equal to the entered value.',
          },
          maxChoices: {
            min: 'The minimum value is 0.',
            length: 'The number of responses is less than the entered value.',
          },
        },
      },
      authorizerList: {
        errors: {
          authorizerNotFound:
            'Authorizer not found on the list of authorizers.',
        },
      },
      questionList: {
        started: 'Active',
        stopped: 'Stopped',
        draft: 'Draft',
        startedText: 'Election started at {value}',
        stoppedText: 'Duration from {from} to {to}',
        verify: {
          startQuestion: 'Are you sure you want to run an election?',
          stopQuestion: 'Are you sure you want to stop the election?',
        },
        errors: {
          questionNotFound: 'The question was not found in the question list.',
        },
      },
      questionStatistics: {
        totalActiveVoters: 'Total number of active voters:',
        /* totalActiveVoters:
          "EN: Total number of active voters \nES: Número total de votantes activos \nFR: Nombre total d'électeurs actifs:", */
        quorumRequired: 'Required quorum:',
        theseAreTheResults: 'These are the results of the vote',
        /* theseAreTheResults:
          'EN: These are the results of the vote \nES: Estos son los resultados de la votación \nFR: Voici les résultats du vote', */
        totalVotes: 'Total numbers of votes:',
        /* totalVotes:
          'EN: Total numbers of votes \nES: Número total de votos \nFR: Nombre total de votes:', */
        noResults: 'No results. No one voted.',
        refreshResults: 'Refresh results',
        voters: 'Participants',
        abstentioned: 'Restrained',
        notStarted: 'Vote not started and there are no results.',
      },
    },
    loginScreen: {
      login: 'Login',
      register: 'Registration',
      forgotPassword: 'Forgot your password?',
      reset: 'Reset password',
      back: 'Back',
      switchToEnglish: 'Switch to English',
      switchToCroatian: 'Switch to Croatian',
      tfaDescription:
        'The authentication PIN was sent by SMS to your mobile phone. Please enter it to continue.',
      check: 'Check',
    },
    footer: {
      userManual: 'Instructions for use',
      support: 'Support',
    },
    toolbar: {
      logout: 'Logout',
    },
    resultsLabels: {
      votingResults: 'Voting results',
      votingDetails: 'Voting details',
      currentVotingStatus: 'Current voting status',
      notEnough: 'At least 10 votes are required to show voting results.',
      initial_email_fail_hard: 'Failed to deliver voting invitations (hard)',
      initial_email_fail_soft: 'Failed to deliver voting invitations (soft)',
      initial_email_delivered: 'Delivered e-mail invitations to vote',
      initial_email_sent: 'Invitations sent to the voter',
      initial_email_read: 'Invitations that are read',
      vote_link_opened: 'Voters who opened the voting link',
      sms_sent: 'Voters who requested a PIN via SMS',
      sms_recieved: 'Voters who received a PIN via SMS',
      pin_checked_true: 'Voters who entered the correct PIN',
      pin_checked_false: 'Voters who entered the wrong PIN',
      voted: 'Voters who voted',
      sms_rejected: 'Voters whose SMS was rejected',
      active_voters: 'Active number of voters',
    },
    titles: {
      results: 'Results',
    },
    fields: {
      authorizers: 'Authorizers',
      event_quorum_value: 'Value',
      search: 'Search',
      name: 'Name',
      name_and_surname: 'Name and surname',
      event_name: 'Internal name of the event',
      surname: 'Surname',
      email: 'E-mail',
      mobile: 'Phone number',
      password: 'Password',
      start: 'Start',
      end: 'End',
      start_date: 'Event start date',
      end_date: 'Event end date',
      start_time: 'Event start time',
      end_time: 'Event end time',
      status: 'Status',
      option: 'Option',
      addOption: 'Enter the new answer or leave it blank',
      new_option: 'New option',
      voters: 'Paticipants',
      header: 'Ballot header',
      footer: 'Ballot footer',
      intro: 'Introduction',
      introTitle: 'Title of the e - mail invitation to the participants',
      intro_text: 'Content of the e - mail invitation to the participants',
      reminder_title: 'Title',
      reminder_text: 'Reminder text',
      help_contact: 'E-mail organizer support',
      question: 'Question',
      event_title: 'Event title',
      time: 'Time',
      step: 'Step',
      maximum_choices: 'Maximum number of possible answers',
      minimum_choices: 'Minimum number of possible answers',
      old_password: 'Old password',
      new_password_1: 'New password',
      new_password_2: 'New password repeated',
      eventTags: 'Internal event categorization tags',
      tags: 'Internal tags',
      event: 'Events',
      phone: 'Phone',
      subject: 'Subject',
      message: 'Message',
      clientName: 'Name',
      address: 'Address',
      city: 'City',
      country: 'Country',
      oib: 'OIB',
      contact_person: 'Contact person',
      contact_email: 'Contact e-mail',
      allowed_domains: 'Allowed domains',
      eventType: 'Event type',
      weight: 'Weight',
      tokensPro: 'Tokens',
      tokens2fa: '2fa Tokens',
      pin: 'PIN',
      tfaEnabled: 'Enabled',
      voted: 'Voted',
      authorizer: 'Authorizer',
    },
    tabs: {
      general: 'General',
      ballot: 'Participants',
      communication: 'Communication',
      results: 'Results',
      log: 'Log',
      voters: 'Elections and statistics',
      messages: 'Invitations',
      emailInvitation: 'E-mail invitation',
      emailReminder: 'E-mail reminder',
      emailSupport: 'Support to participants',
      options: 'Documents',
      publish: 'Publish',
      test: 'Agenda',
    },
    modules: {
      dashboard: 'Dashboard',
      voterGroups: 'Group of participants',
      events: 'Events',
      event: 'Event',
      settings: 'Settings',
      upgrade: 'Account upgrade',
      newEvent: 'New event',
    },
    dataTable: {
      rowsPerPage: 'Rows per page:',
      results: 'Results',
      of: 'of',
      search: 'Search',
      all: 'All',
    },
    alerts: {
      eventTypeTransparent:
        'By choosing this option the voting will not be anonymous.',
      quorumValueEmpty: 'You must enter a quorum value.',
      quorumValueNotInteger: 'Quorum value must be an integer.',
      quorumValueMin: 'Minimum quorum value is 1.',
      maxFileSizeLimit: 'You cannot enter more than 8MB per file.',
      refreshPage: 'Refresh page?',
      closeQuestionCreate:
        'Are you sure you want to leave this screen without saving?',
      startEvent:
        'Are you sure you want to run this event? Once started, the event can only be stopped, but not restarted.',
      stopEvent:
        'Are you sure you want to stop this event? Once stopped, the event can only be stopped, but not restarted',
      resendSingleQuestion: 'Do you want to send an e-mail to the participant?',
      resendQuestion: 'Are you sure you want to re-email the voter?',
      optionDeletionQuestion: 'Are you sure you want to delete this option?',
      questionDeletionQuestion:
        'Are you sure you want to delete this question?',
      voterDeletionQuestion: ' Are you sure you want to delete this voter?',
      deletionQuestion: 'Are you sure you want to delete this record?',
      deletionQuestionAdditional:
        'Are you absolutely sure you want to delete this record?',
      cloneQuestion: 'Are you sure you want to duplicate this record?',
      archiveQuestion: 'Are you sure you want to archive this record?',
      nameMissing: 'You did not enter an event name.',
      firstnameMissing: 'You did not enter a name.',
      nameTooLong: 'Name cannot be longer than 40 characters.',
      reminderTitleTooLong:
        'Reminder title cannot be longer than 50 characters.',
      nameLength: 'The name must be at least two characters long.',
      surnameMissing: 'You did not enter a last name.',
      surnameLength: 'Last name must be at least two characters long.',
      mobileMissing: 'You did not enter a cell phone number.',
      mobileFailFormat: 'The cell phone number is in the wrong format.',
      phoneMissing: 'You did not enter a phone number.',
      phoneFailFormat: 'The phone number is in the wrong format.',
      emailMissing: 'You did not enter an email.',
      emailVerification: 'E-mail is invalid.',
      email1Verification: 'E-mail 1 is invalid.',
      email2Verification: 'E-mail 2 is invalid.',
      email3Verification: 'E-mail 3 is invalid.',
      emailDomain: 'E-mail domain not approved.',
      passwordMissing: 'You did not enter a password.',
      passwordSpaces: 'Password must not contain spaces.',
      startDateMissing: 'You have not selected a start date.',
      startTimeMissing: 'You did not select a start time.',
      startTimeVerification: 'Invalid start time.',
      endDateMissing: 'You have not selected an end date.',
      endTimeMissing: 'You did not select an end time.',
      endTimeVerification: 'End time is invalid.',
      helpContactMissing: 'You did not enter an email to support voters.',
      helpContactFormat: 'Support email is invalid.',
      votersMissing: 'You did not select participants.',
      questionsMissing: 'You did not enter any questions.',
      questionsDuplicate: 'You typed a question twice.',
      questionEmpty: 'You have a question without text.',
      optionsDuplicate:
        'You have entered the same option twice within one question.',
      optionEmpty: 'There is an answer that is empty.',
      notEnoughOptions: 'Each question must have at least two options.',
      tooManyOptionsMax:
        'There is a question for which the number of options is less than the maximum number of selections.',
      tooManyOptionsMin:
        'There is a question for which the number of options is less than or equal to the minimum number of selections.',
      maxZero: 'The maximum number of selections must not be zero.',
      minZero: 'The minimum number of selections must not be zero.',
      headerMissing: 'You did not enter a header.',
      footerMissing: 'You did not enter a footer.',
      introMailMissing:
        'You did not enter the content of the voting invitation email.',
      introMailTitleMissing:
        'You did enter the subject of the voting invitation email.',
      introMailTitleTooLong:
        'Invitation email subject cannot be longer than 180 characters.',
      reminderMailMissing:
        'You did not enter the contents of the voting reminder email.',
      reminderMailTitleMissing:
        'Yout did not enter the subject of the voting reminder email.',
      wrongCredentials: 'You have entered incorrect user information.',
      noData: 'No data.',
      noResults: 'No results.',
      voterExists: 'A voter with that email or cell phone already exists.',
      failed: 'Failed: ',
      added: 'Added: ',
      newOptionEnter: 'Press enter to add a new option.',
      eventStatusFail:
        'Status is invalid. Only the "Draft" and "Published" statuses can be set manually.',
      eventSmsFail: 'There is a voter without mobile phone number.',
      leaveQuestion:
        'Are you sure that you want to leave this screen without saving?',
      eventMissing: 'Events must be selected.',
      publishWarning:
        'Please check election token number before starting the election. If you do not have enough tokens, the election or question will not be able to be started.',
      publishQuestion: 'Are you sure you want to post the event?',
      passwordResetSuccess: 'Please check your email.',
      passwordResetFail: 'There is no user with this email address.',
      newPasswordMissing: 'You did not enter a new password',
      passwordMatch: 'New passwords do not match.',
      passwordLength: 'The new password must be at least 8 characters long.',
      newPasswordOldPasswordMatch: 'New and old passwords must be different.',
      passwordChangeSuccess: 'Your password has been changed.',
      passwordChangeError: 'Your old password is incorrect.',
      timesWrong:
        ' The end time of voting must be after the time of the beginning of voting.',
      automaticReminderWrong:
        'The number of days for automatic reminders must be shorter than the duration of the event.',
      automaticReminderZero:
        'The number of days for automatic reminders must not be 0.',
      noVoters: 'No voters added for this event.',
      startTimeInThePast: 'The start time cannot be in the past',
      maximumEmailsSent:
        'Email cannot be sent. The maximum number of emails has already been sent to this voter.',
      logoutConfirmation: 'Are you sure you want to log out?',
      userDisabled:
        'Your account has been locked because you entered the wrong pin more than 3 times. To unlock your account, click on the link sent to your email address.',
      votersClearQuestion: 'Are you sure you want to remove all participants?',
      invalidImport: 'Fields are not entered correctly.',
      fileDeletionQuestion: 'Are you sure you want to remove this file?',
      nameSurnameMissing: 'A name and surname are required.',
      subjectMissing: 'A subject is required.',
      messageMissing: 'A message is required.',
      supportSuccess: 'Message sent.',
      eventTooLong: 'Maximum event duration is one month.',
      eventNoVoters: 'The selected event has no voters.',
      domainsError:
        'You cannot make this domain change since there is a voter that does not match the new settings.',
      voterDeactivationQuestion:
        'Are you sure you want to deactivate the voter?',
      deactivationVoterVoted:
        'Voter cannot be deactivated as they have already voted.',
      excelNoVoters: 'No voters in list.',
      testEmailsMissing: 'No addresses have been input.',
      pinMatch: 'The numbers you have inputted are mismatched.',
      purchase: 'Your order is being processed. We will contact you soon.',
      tokensNotAvailable:
        'Insufficient Tokens. To activate additional Tokens, please contact us at info@fair-votes.com.',
      tfaPopup:
        'We recommend enabling two-factor authentication for your account.',
      savedPopup: 'Changes saved.',
      emailVotedError:
        'You cannot send a reminder to this voter as they have already voted.',
      pageRefreshed: 'Page refreshed',
      testSent: 'Invitations sent.',
      invalidWeight: 'Weight cannot be 0.',
      removeEmailsFirst:
        'Please remove all voters before changing the domain settings.',
      tokenPurchaseRequestQuestion:
        'Are you sure you want to send the request?',
      clientExpired: "Your account has expired.",
    },
    buttons: {
      back: 'Back',
      archive: 'Archive',
      clone: 'Clone',
      preview: 'Preview elections',
      new: 'New',
      createNew: 'Create new events',
      save: 'Save',
      cancel: 'Cancel',
      yes: 'Yes',
      no: 'No',
      ok: 'OK',
      delete: 'Delete',
      edit: 'Edit',
      addQuestion: 'Add question',
      passwordSet: 'Set password',
      passwordChange: 'Change password',
      next: 'Next',
      all: 'All',
      completed: 'Completed',
      active: 'Active',
      published: 'Published',
      drafts: 'Drafts',
      editInfo:
        'Additional info will be visible on the election as a short description next to an answer',
      addVoter: 'Add voter',
      loadVoters: 'Load voters from other events',
      importVoters: 'Import voters from Excel spreadsheet',
      downloadTemplate: 'Download template',
      downloadVoters: 'Download voters list',
      resendEmail: "Resend e-mail to voters that haven't yet voted.",
      sendEmailVoter: 'Send e-mail to voter',
      publish: 'Publish',
      moveUp: 'Change question order',
      moveDown: 'Change question order',
      nextStep: 'Next step',
      loadLog: 'Load logs',
      refreshLog: 'Refresh logs',
      loadData: 'Load from other events',
      loadBallot: 'Load ballot from other events',
      voterHistory: 'Show voter history',
      sendSms: 'Send SMS',
      send: 'Send',
      close: 'Close',
      saveDraft: 'Save as draft',
      deactivate: 'Deactivate',
      test: 'Test',
      refresh: 'Refresh',
      pdf: 'PDF',
      buy: 'Purchase',
    },
    labels: {
      enableAudioVideo: 'Enable Audio/Video',
      voterUiType: 'Mode',
      voterUiTypeBasic: 'Basic',
      voterUiTypeAdvanced: 'Advanced',
      eventType: 'Event type',
      anonymous: 'Anonymous',
      transparent: 'Transparent',
      addOptionEnter: 'Add with "Enter"',
      multiple_choices_enabled: 'Enable multiple choices',
      maximumChoices: 'Use 0 for unlimited.',
      noResultsEvents: 'There are currently no active events.',
      noResultsEventsDetails:
        'To publish a new event, all fields are required. After the events are finished, you may deactivate or delete them at your convenience. Deleted events will no longer be available. For detailed instructions on how to use the FairVotes.LIVE platform please click on "Help" at the top of the screen',
      noResultsEventsFilter: 'No events in this category.',
      noResultsEventsSearch: 'No search results.',
      singleAuthentication: "Simple authorization - via voter's e-mail address",
      doubleAuthentication:
        "Two-factor authorization - via voter's address and mobile device number (SMS)",
      showResults: 'Show election results',
      eventLanguage: 'Language',
      results_in_progress_1:
        'During voting period  - not visible if each individual voter voted.',
      results_in_progress_2:
        'After voting period - visible if each individual voter voted',
      automatic_reminders_1:
        " Send an e-mail reminder to all voters that didn't vote every ",
      automatic_reminders_2: ' days',
      abstention: 'Allow voter abstention for this question',
      manual_reminders: 'Allow manual voting reminders during election',
      adding_voters_in_progress: 'Allow adding voters during election',
      alreadySent: 'Already sent',
      smsSent: 'SMS has been sent to the voter',
      unsubscribed: 'This voter has unsubscribed.',
      helpContactInfo: 'Event user support.',
      optionDescription: 'Option description',
      accountUpgrade: 'Upgrade<br />account',
      publishText:
        'Once all the fields have been filled in, checked and confirmed by the administrator, click the "Publish" button. Once the events have been published, it is not possible to edit or delete them until the event is finished.',
      testText:
        'Once all the fields have been filled in, checked and confirmed by the administrator, click the "Test" button to publish your testing<br />You will receive an invitation and ballot link to your e-mail (testing is available in the form of simple authentication).',
      search: 'Search by name or tag',
      dropdownNoData: 'No data currently available.',
      editVoter: 'Edit voter',
      addVoter: 'Add voter',
      randomizeOptions: 'Randomize options',
      identityConfirmation: 'Confirm participant identity',
      editInfoTitle: 'Additional option info',
      mobileHint: '+385xxxxxxxxx or 09xxxxxxxx',
      appLanguage: 'Choose app language',
      changePassword: 'Change password',
      emailRecieved: 'E-mail received',
      emailOpened: 'E-mail opened',
      linkClicked: 'Link clicked',
      all: 'All',
      supportTitle: 'Support',
      supportText: 'Please enter your query, bug report or suggestion.',
      uploadInProgress: 'Upload in progress.',
      attachmentPhoto: 'Attachment (photo)',
      licenseDetails: 'License details',
      unlockText:
        'Your user account has been unlocked. A new password will be delivered to your e-mail.',
      answer: 'Answer',
      allowAllDomains: 'Allow all domains',
      archive: 'Archive',
      voted: 'Voted',
      inactive: 'Inactive',
      domainExplanation:
        'To add allowed domains please input the domain and press enter.',
      allow_unsubscriptions: 'Allow voter to unsubscribe from reminder list',
      eventTypeClassic: 'Standard voting - 1 participant = 1 vote',
      eventTypeWeighted:
        'Weighted voting - 1 participant = dependent on participant voting importance',
      testDialogTitle: 'Enter testing addresses',
      deleteDialog:
        'Are you sure you wish to delete this election? The election will be permanently removed and cannot be recovered.<br />If you wish to delete, please enter the following numbers:<br /><br />',
      sendPdf: "Automatically send results to participant's e-mail",
      tokensTitle: 'Available Tokens:',
      tokensPlayground: 'Available Playground Tokens:',
      tokensPro: 'Available Pro Tokens:',
      tokens2fa: 'Available 2fa Tokens:',
      tokensExplanation:
        'Upon account creation you are granted 50 free Tokens used for simple-authentication election. You cannot use two-factor authentication with free Tokens (SMS).',
      tokensFormTitle: 'Purchase Tokens',
      piece: 'pcs',
      emailBounce: "E-mail couldn't be delivered",
      smsBounce: "SMS couldn't be delivered",
      tfa: 'Two-factor authentication',
      allowed_domains: 'Permitted domains',
      yes: 'Yes',
      no: 'No',
      enable_live_questions: 'Live participant questions',
      live_questions_visibility: 'Question visibility',
      live_questions_visibility_organizer: 'Administrator',
      live_questions_visibility_organizer_and_voters: 'Administrator and users',
      warmup_message: 'Content shown to participants before elections begin',
      technical_details_text:
        'E-mail invitation content (TECHNICAL INSTRUCTIONS)',
      agenda: "Enter your event's agenda",
      logo_upload: 'Logo upload',
      document_upload: 'Add document',
      quorum: 'Quorum',
      tokenExplanationGeneralTitle: 'Explanation of Token use',
      tokenExplanationGeneralPerEvent:
        'Starting the Event = Token * (No. of voters/authorizers)',
      tokenExplanationGeneralPerQuestion:
        'Starting each Question = Token * (No. of voters/authorizers)',
      tokenExplanationGeneral2fa:
        '2fa Tokens are only used for starting the Event, and are not needed for starting the Questions.',
      tokenExplanationAuthorizersTitle:
        'Additional explanation of using Tokens for authorizers',
      tokenExplanationAuthorizersZero: 'Voter without authorizers = 1 Token',
      tokenExplanationAuthorizersOne: 'Voter with 1 authorizer = 1 Token',
      tokenExplanationAuthorizersTwo: 'Voter with 2 authorizers = 2 Tokens',
      tokenExplanationAuthorizersN: 'Voter with n authorizers = n Tokens',
    },
    importLabels: {
      totalRecords: '<b>Total number of records: </b>',
      importedRecords: '<b>Imported records: </b>',
      emptyEmail: '<b>Records with no e-mail address: </b>',
      domainEmail: '<b>Records with forbidden domains: </b>',
      failedEmail: '<b>Records with forbidden e-mail addresses: </b>',
      failedMobile: '<b>Records with incorrect mobile device number: </b>',
      duplicates: '<b>Duplicate records(e-mail or mobile): </b>',
    },
    languages: {
      en: 'English',
      hr: 'Croatian',
      sl: 'Slovenian',
    },
    ballot: {
      footer:
        'FairVotes.LIVE is an electronic voting system developed by IDE3 d.o.o.. All rights reserved.',
      wrongTokenPreview: 'The link is not active.',
      wrongTokenVote:
        "This page is no longer active. Your vote has already been recorded or the voting period has ended. Esta página ya no está activa. Su voto ya ha sido registrado o el período de votación ha finalizado. Cette page n'est plus active. Votre vote a déjà été enregistré ou la période de vote est terminée.",
      previewAlert: 'This is only a ballot preview. Your vote cannot be cast.',
      step1:
        'FairVotes elections: %title%<br />Administrator: %client%<br />Voting deadline: %end%<br /><br />Greetings,<br/><br />please ready your mobile device for voting authorization.<br /><br />An authorization PIN will be sent to your mobile device via SMS (the reported number ends with <b>***%phone_number%</b>). The authorization PIN is active for 2 hours after activation.<br /><br />For any additional questions please contact the voting administrator at %help_contact%.',
      step2:
        "Greetings,<br/><br/>Please enter the PIN you've received via SMS to your mobile device (the reported number ends with <b>***%phone_number%</b>).<br/><br/>If you haven't received any message, please click below to send again.",
      btnAuthenticate: 'AUTHENTICATE',
      btnPinProblem: 'NO SMS OR EXPIRED PIN?',
      completed: 'Voting on this subject has been finished.',
      voteCasted: 'Your vote has been cast.',
      pinAlert: 'PIN was requested too many times. Contact the administrator',
      pinFail: 'PIN is invalid or expired.',
      oneOption: 'An option must be selected',
      multipleOptionsA_1: 'must be selected',
      multipleOptionsA_2: 'options',
      multipleOptionsB_1: 'must select from',
      multipleOptionsB_2: 'up to',
      multipleOptionsB_3: 'options',
      abstent: 'Abstain',
      btnVote: 'Vote',
      abstentionLock: "You cannot choose an answer if you're abstaining.",
      wrongNumberOfOptions: 'Wrong number of selected options.',
      unsubscribeSuccess: 'Successfully unsubscribed.',
      unsubscribeQuestion:
        'Are you sure you wish to unsubscribe from the online voting list?',
      expired: 'You cannot vote, the election is over.',
      wrongSession:
        'Voting is already in session on another device. Please close the link you opened earlier or reopen the voting link in 5 minutes.',
    },
    statuses: {
      draft: 'Draft',
      published: 'Published',
      active: 'Active',
      completed: 'Completed',
      archive: 'Archived',
    },
    filters: {
      active: 'Active',
      sms: 'SMS',
      status: 'Status',
      helpFilter: 'Help filter',
      help: 'Help',
      active1: 'Active',
      active0: 'Inactive',
      sms0: '0 PINs requested',
      sms1: '1 PIN requested',
      sms2: '2 PINs requested',
      sms3: '3 PINs requested',
      sms4: 'over 3 PINs requested',
      emailSent1: 'E-mail sent',
      emailSent0: 'E-mail not sent',
      emailReceived1: 'E-mail received',
      emailReceived0: 'E-mail not received',
      emailOpened1: 'E-mail opened',
      emailOpened0: 'E-mail unopened',
      linkOpened1: 'Voting link opened',
      linkOpened0: 'Voting link unopened',
      pinRequested1: 'PIN requested',
      pinRequested0: 'PIN not requested',
      pinReceived1: 'PIN received',
      pinReceived0: 'PIN not received',
      voted1: 'Voted',
      voted0: 'Not voted',
      voterOnline1: 'Voter online',
      voterOnline0: 'Voter offline',
    },
    tooltips: {
      downloadEventPdf: 'Download PDF with results',
      newEvent: 'Create new event',
      loadBallot:
        'Fill out header, title, footer and questions from other events',
      addQuestion: 'Add question to ballot',
      addVoter: 'Add voter or list of voters',
      loadVoters: 'Load existing voter list from other events',
      importVoters: 'Import voter list from Excel spreadsheet',
      downloadTemplate: 'Download Excel template to import voter list',
      downloadVoters: 'Download voter list',
      loadEmailData:
        'Fill out e-mail title, body and address with info from other events',
      publish: 'Publish elections',
      back: 'Back to events list',
      save: 'Save event',
      nextStep: 'Next step',
      edit: 'Edit selected events',
      preview: 'Preview e-ballot',
      clone: 'Clone',
      delete: 'Delete selected events',
      archive: 'Archive selected events',
      clearVoters: 'Empty voter list',
      resultsInProgress:
        'We recommend you show results "After elections end" for transparency and removing the possibility or influencing the voters on the basis of current election results.',
      saveDraft: 'Save as draft',
      test: 'Test',
      audioVideoTooltip:
        'To edit Audio/Video settings, please contact your administrator',
      questionAnonymity:
        'If not selected, the question anonymity will depend on the event setting',
    },
  }
}
